module.exports = __webpack_public_path__ + "static/media/pozuelo@3x.13e74be9.jpg";